// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BragFormController from "./brag_form_controller"
application.register("brag-form", BragFormController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import ExitAnimationController from "./exit_animation_controller"
application.register("exit-animation", ExitAnimationController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
